import { ActionReducerMapBuilder, AsyncThunk, Reducer } from '@reduxjs/toolkit';

export function apiReducerBuilder<T, U>(
	builder: ActionReducerMapBuilder<any>,
	customThunk: AsyncThunk<
		T,
		U,
		{
			rejectValue: any;
		}
	>,
	callback: Reducer,
) {
	return builder
		.addCase(customThunk.fulfilled, callback)
		.addCase(customThunk.pending, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
		})
		.addCase(customThunk.rejected, (state, action) => {
			const { meta } = action;

			state.status = meta.requestStatus;
		});
}
